import { StatisticsCode } from '@entity/statistics-code';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCrudMandantService } from '@service/abstract-crud-mandant.service';

@Injectable({
  providedIn: 'root',
})
export class StatisticsCodeService extends AbstractCrudMandantService<StatisticsCode> {
  constructor() {
    const httpClient = inject(HttpClient);

    super('statistics-codes', httpClient);
  }
}
